// extracted by mini-css-extract-plugin
export default {"card":"VTI9uxNPs32dNEjr5UBg","borderBottom":"k5tzmfFqCVBZ6CDm1bGX"};